module.exports = "<svg viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"9\" width=\"24\" height=\"13\" fill=\"currentColor\" fill-opacity=\"0.16\"></rect><path d=\"M4 9H28\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path><path d=\"M10 16V22H22V16H10Z\" fill=\"rgba(255,255,255,0.72)\"></path><path d=\"M4 22H9C9.55228 22 10 21.5523 10 21V17C10 16.4477 10.4477 16 11 16H21C21.5523 16 22 16.4477 22 17V21C22 21.5523 22.4477 22 23 22H28\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/tab-rect.svg
// module id = LEfi
// module chunks = 1